import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import i18n from '../../i18n';
import useAppContext from '../../AppContext';
import { Link, useParams, useNavigate, useLocation} from 'react-router-dom';
import Pagination from '../../pagination.js';
import { Spinner } from "react-bootstrap";
import styles from './job-sub-category.module.css';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const JobSubCategory = () => {

  const { t } = useTranslation();
  const appContext = useAppContext();
  const params = useParams();
  const navigate = useNavigate();
  const search = useLocation().search;
  const Axios = appContext.getAxios();
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [subCategoryId, setSubCategoryId] = useState();
  const limit = 10;
  const [count, setCount] = useState(10);
  const [currentPage, setCurrentPage] = useState(parseInt(params.page));
  const [lastPage, setLastPage] = useState();
  const [isLoaded, setIsLoaded] = useState(false);
  const [response, setResponse] = useState(false);
  const [errorCode, setErrorCode] =  useState();
  const [freeWord, setFreeWord] =  useState(new URLSearchParams(search)?.get('search'));
  useEffect(() => {
    window. scrollTo(0, 0);
    i18n.changeLanguage(localStorage.getItem("LANGUAGE"));
    getJobSubCategory(currentPage);
    window.addEventListener('popstate', onBackButtonEvent);
    // eslint-disable-next-line 
  }, []);
  const onBackButtonEvent = (e) => {
    e.preventDefault();
    window.location.reload()
  }
  function getJobSubCategory(page) {
    appContext.setError(null);
    appContext.setSuccess(null)
    if(freeWord === ""  || !freeWord){
      Axios.get("subCategory?page="+page+"&size="+limit).then((response) => {
        setSubCategoryList(response.data.subCategoryList);
        setCount(response?.data?.totalCount);  
        setLastPage(response?.data?.totalPages);
        setIsLoaded(true);
    console.log(subCategoryList);
    const totalPageCount = Math.ceil(response?.data?.totalCount / limit);
    if(page > totalPageCount){
      setCurrentPage(currentPage-1);
      if(totalPageCount !== 0){
        navigatePage(currentPage-1);
      }else{
        setCurrentPage(1);
      }
    }
  }).catch(error => {
    setIsLoaded(true);
    console.log('There was an error!', error);
  });
    }else{
      Axios.get("subCategory?page="+page+"&size="+limit+"&search="+freeWord).then((response) => {
        setSubCategoryList(response.data.subCategoryList);
        setCount(response?.data?.totalCount);  
        setLastPage(response?.data?.totalPages);
        setIsLoaded(true);
    console.log(subCategoryList);
    const totalPageCount = Math.ceil(response?.data?.totalCount / limit);
      if(page > totalPageCount){
        setCurrentPage(currentPage-1);
        if(totalPageCount !== 0){
          navigatePage(currentPage-1);
        }
      }
  }).catch(error => {
    setIsLoaded(true);
    console.log('There was an error!', error);
  });
    }
}
function deleteSubCategory(id){
  appContext.setError(null);
  appContext.setSuccess(null)
    Axios.delete('subCategory/'+id).then(
      (response) => {
        setResponse(true)
        console.log(response);
        getJobSubCategory(currentPage);
        window. scrollTo(0, 0);
        appContext.setSuccess(t("sub_category.sub_category_deleted"))
      },
      (error) => {
        console.log(error)
        setResponse(false);
        getJobSubCategory(currentPage);
        window. scrollTo(0, 0);
        setErrorCode(error.response?.data?.errorCode);
        if(error.response?.data?.errorCode === "3000"){
          setSubCategoryId(id);
          document.getElementById("deletePopUpButton").click();
        }else if(error.response?.data?.errorCode === "33301"){
          appContext.setError(t("sub_category.sub_category_not_found"))
        }else{
          appContext.setError(t("error"))
        }
      
      }
    );
  }
  function deleteSubCategoryForce(id){
    appContext.setError(null);
    appContext.setSuccess(null)
    Axios.delete('subCategory/'+id+"?forceDelete=1").then(
      (response) => {
        setResponse(true)
        console.log(response);
        getJobSubCategory(currentPage);
        window. scrollTo(0, 0);
        appContext.setSuccess(t("sub_category.sub_category_deleted"))
      },
      (error) => {
        console.log(error)
        setResponse(false);
        window. scrollTo(0, 0);
        setErrorCode(error.response?.data?.errorCode);
        appContext.setError(t("error"))
      }
    );
  }
  function pageChange(page) {
    if(page === currentPage){
      return;
    }
    setCurrentPage(page);
    if (page >= 1 && page <= lastPage) {
      navigatePage(page);
    }
  }
  function navigatePage(page) {
    if(freeWord === "" || freeWord === null){
      navigate("/job-sub-category/"+page);
    }else{
      navigate("/job-sub-category/"+page+"?search="+freeWord.trim());
    }
    getJobSubCategory(page);
    window. scrollTo(0, 0);
   }
   function clickDelete(id){
    deleteSubCategory(id)
  }
  function handleDelete(){
    deleteSubCategoryForce(subCategoryId)
  }
   function handleClosePopup(){
    if(subCategoryList.length === 0 && currentPage > 1){
      navigate("/job-sub-category/"+(currentPage-1));
      getJobSubCategory(currentPage-1);
      setCurrentPage(currentPage-1);
    }else{
      getJobSubCategory(currentPage);
    }
  }
  const handleKeyDown = (e) =>{
    if (e.key === 'Enter') {
      freeWordSearch();
    }
  }
  const handleOnChangeFreeText = (event) => {
    setFreeWord(event.target.value)
    console.log(freeWord)
  }
  function freeWordSearch(){
    setCurrentPage(1);
    getJobSubCategory(1);
    if(freeWord === "" || freeWord === null){
      navigate("/job-sub-category/1");
    }else{
      navigate("/job-sub-category/1?search="+freeWord);
    }
  }
  return(
  <div className={styles.JobSubCategory} data-testid="JobSubCategory">
        <div>
                    <div class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-4 pb-4">
                        <h5>{t('job_sub_category')}</h5>
                        <div class="col-md-7">
                            <div class="row">
                                <div class="col-md-4">
                                <Link to="/create-job-sub-category"  state={{page:currentPage,
                                                          id:null,
                                                          search:freeWord,
                                                          value:null,
                                                          categoryId:null,
                                                          categoryName:null}}>
                                  <button class="create-btn mt-3 mb-3"><i class="fa-solid fa-plus"></i>{t('sub_category.create_sub_category')}</button></Link>
                                </div>
                                <div class="col-md-8">
                                    <div class="input-group mt-3 mb-3">
                                        <input type="text" class="form-control custom-search" placeholder={t('search_by_sub_category')} onKeyDown={handleKeyDown}
                                         value={freeWord} onChange={e => handleOnChangeFreeText(e)}  aria-label="Search" aria-describedby="basic-addon2" id="myInputID"/>
                                        <button type="button" class="input-group-text search-btn" id="basic-addon2" onClick={freeWordSearch}><i
                                                class="fa-solid fa-magnifying-glass"></i></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {isLoaded ?  
                    <div>
                 {subCategoryList?.length > 0 ?  <div class="card table-card">
                        <div class="card-body p-0">
                            <div class="table-responsive">
                                <table class="table custom-table1 text-center">
                                    <thead class="table-header">
                                        <tr>
                                            <th scope="col" style={{"width":"15%"}}>{t('sl_no')}</th>
                                            <th scope="col" style={{"width":"30%"}}>{t('sub_category.sub_category_name')}</th>
                                            <th scope="col" style={{"width":"30%"}}>{t('category.category_name')}</th>
                                            <th scope="col" style={{"width":"10"}}>{t('action')}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {subCategoryList.map(( subCategory, index ) => {
                                       return (
                                        <tr>
                                            <td>{(index+1)+(limit*(currentPage-1))}</td>
                                            <td style={{"maxWidth":"50px"}}><span className="table-text">{subCategory?.subCategoryName}</span></td>
                                            <td style={{"maxWidth":"50px"}}><span className="table-text">{subCategory?.category?.categoryName}</span></td>
                                            <td>
                                            <div class="row text-center">
                                                    <div class="col-md-12  ">
                                                    <Link to={"/create-job-sub-category?id="+subCategory?.subCategoryId}
                                                   state={{page:currentPage,
                                                          id:subCategory?.subCategoryId,
                                                          search:freeWord,
                                                          value:subCategory?.subCategoryName,
                                                          categoryId:subCategory?.category?.categoryId,
                                                          categoryName:subCategory?.category?.categoryName}}>
                                                            <button class="edit-btn me-2 mbt-3"><i
                                                                class="fa-solid fa-pen"></i></button></Link>    
                                                        <button class="delete-btn me-2 "  onClick={() => clickDelete(subCategory?.subCategoryId)}><i
                                                                class="fa-solid fa-trash-can"></i></button>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>)})}

                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>: <div><h6 style={{ "textAlign": "center","fontWeight":"bold","lineHeight":"400px" }}>{t('sub_category.sub_category_not_found')}</h6></div>}
                    </div> : <Spinner style={{ "color": "#02c090", "height": "50px", "width": "50px","marginTop":"150px" }}></Spinner> }



                  {isLoaded? <div class="col-md-12 mt-5">
                        <nav aria-label="Page navigation example">
                            <ul class="pagination justify-content-end">
                            <Pagination
                                  className="pagination-bar"
                                  currentPage={currentPage}
                                  totalCount={count}
                                  pageSize={limit}
                                  onPageChange={page => pageChange(page)}
                                />
                            </ul>
                        </nav>
                    </div> :  null}
                </div>

                                {/*SUCCESS POPUP */}
       <a href="" class="edit-icon" data-bs-toggle="modal" id="successPopUpButton" data-bs-target="#successPopup" hidden></a>

<div class="modal fade" id="successPopup" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog modal-confirm ">
    <div class="modal-content">
      <div class="modal-header justify-content-center">
        <div class="icon-box">
          {response === true ? <i class="fa fa-check" aria-hidden="true"></i> : <i class="fa fa-exclamation-triangle" aria-hidden="true"></i>}
        </div>
       <button type="button" id="successPopUpCloseButton" class="successPopup-Close-btn"
          data-bs-dismiss="modal" aria-label="Close" onClick={handleClosePopup}><i class="fa-solid fa-xmark"></i></button>
      </div>
      <div class="modal-body text-center">
        {response === true ? <h4>{t('success')}</h4> : <h4>{t('error')}</h4>}
        {(response === true ) ? <p>{t('sub_category.sub_category_deleted')}</p> : null}
        {response === false && errorCode === "33301" ? <p>{t('sub_category.sub_category_not_found')}</p> : null}
        <button class="btn btn-success btn-lg" data-bs-dismiss="modal" onClick={handleClosePopup}><span>{t('ok')}</span></button>
      </div>
    </div>
  </div>
</div>

  {/*DELETE POPUP */}
  <a href="" class="edit-icon" data-bs-toggle="modal" id="deletePopUpButton" data-bs-target="#deletePopup" hidden></a>

  <div class="modal fade" id="deletePopup" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-lg">
                <div class="modal-content">

                    <div class="modal-body px-5 py-3">
                        <div class="row mb-2 mt-5 px-3">
                            <div class="col-md-12 text-center">
                                <i class="fa-regular fa-circle-xmark delete-pop"></i>
                            </div>

                            <div class="text-center mt-4 mb-4">
                                <h5>{t('warning')}</h5>
                            </div>

                            <div class="text-center">
                                <p>{t('sub_category.sub_category_warning')}</p>
                            </div>


                        </div>
                        <div class="col-md-12 text-center mb-3">
                            <button class="cancel-btn" data-bs-dismiss="modal">{t('cancel')}</button>
                            <button class="main-buttons sub-btn"  data-bs-dismiss="modal" onClick={handleDelete}>{t('delete')}</button>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
        <ToastContainer
        position="bottom-right"
        autoClose={800}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        limit={1}
        pauseOnFocusLoss
        pauseOnHover
        theme="colored"
      />
  </div>
);}

export default JobSubCategory;
